<template>

<div class="add-imei">
    <el-form :model="form" label-position="right" label-width="100px" :rules="rules" style="max-height:500px;overflow:auto" ref="form">
        <el-form-item label="IMEI:" prop="newImei" required>
             <el-input v-model="form.newImei" type="newImei"></el-input>
        </el-form-item>
        <el-form-item label="随机码:" prop="chipid" required>
             <el-input v-model="form.chipid" type="chipid"></el-input>
        </el-form-item>
		<el-form-item label="ICCID:" prop="iccid" required>
		     <el-input v-model="form.iccid" type="chipid"></el-input>
		</el-form-item>
    </el-form>
    <div class="align-right">
        <el-button type="primary" class="themed-button" @click="onSure('form')">确定</el-button>
        <el-button type="primary" class="themed-button" @click="cancle">取消</el-button>
    </div>
</div>

</template>

<script type="text/ecmascript-6">

import {imeiUpdateSave} from '@/api/meCardBindManagement/imeiUpdataList.js'

import { messageBox, confirmBox } from "@/utils/common.js"

import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    data(){
        return {
            form:{
				iccid: "",
				newImei: "",
				chipid: ""
            },
            imeiBankCodeList:[],
            agentList:[],
            rules: {
				newImei: [
					{ required: true, message: '请输入IMEI', trigger: 'blur' }
                ],
                chipid: [
                    { required: true, message: '请输入随机码', trigger: 'blur' }
                ],
				iccid: [
                    { required: true, message: '请输入ICCID', trigger: 'blur' }
                ],
            },
        }
    },
    methods:{
		onSure(formName){
		    this.$refs[formName].validate((valid) => {
		        if (valid) {
		            let params = {}
					if(this.form.imeis){
						params.imeis = this.form.imeis
					}
					if(this.form.newImei && this.form.iccid && this.form.chipid){
						params.newImei = this.form.newImei
						params.iccid = this.form.iccid
						params.chipid = this.form.chipid
					}
		            imeiUpdateSave(params).then(res=>{
		                if (res.system_result_key == '0') {
		                    this.$alert('添加成功', '提示', {
		                        confirmButtonText:'确定',
		                    }).then(()=>{
		                        this.$emit('close-dialog')
		                    });
		                }else{
		                    this.$message({
		                        showClose: true,
		                        message: res.system_result_message_key,
		                        type: 'error'
		                    });
		                }
		            })
		        } 
		    });
		},
        cancle(){
            this.$emit('close')
        },

    }
}
</script>

